import React from 'react'
import Footer from '../../Components/Footer'
import Header from '../../Components/Header'
import Sidebar from '../../Components/Sidebar'
import UpdateContact from './UpdateContact'

const index = () => {
  return (
        <React.Fragment>
            <div className='wrapper'>
                <Header/>
                <Sidebar/>
                <UpdateContact/>
                <Footer/>
                
            </div>
        </React.Fragment>
    )
}

export default index